// extracted by mini-css-extract-plugin
export default {"containerImage":"styles_containerImage__bZo1r","img":"styles_img__jAdDu","startContainer":"styles_startContainer__eKw-j","star":"styles_star__igDMP"};